import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';
import cx from 'classnames';
import { CardBadgeList } from './CardBadgeList';

type Props = {
  badges?: ReactNode[];
  children?: ReactNode;
  className?: string;
  icon?: ReactNode;
  subTitle?: ReactNode;
  title?: ReactNode;
};

export const CardMediaOverlay = (props: Props) => (
  <OverlayWrapper className={cx('card-media-overlay', props.className)}>
    {props.children}
    <div className="card-media-overlay-text">
      {props.title && <span className="title">{props.title}</span>}
      {props.subTitle && <span className="sub-title">{props.subTitle}</span>}
    </div>
    <div className="card-media-overlay-icon">{props.icon}</div>
    <CardBadgeList badges={props.badges} className="card-media-overlay-badges" />
  </OverlayWrapper>
);

const OverlayWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  transition: 0.3s background-color;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;

  &:hover,
  &.hover {
    background-color: rgba(0, 0, 0, 0.5);

    .card-media-overlay-badges {
      background-color: transparent;
    }
    .card-media-overlay-text,
    .card-media-overlay-icon {
      opacity: 1;
    }
  }

  .card-media-overlay-text {
    opacity: 0;
    transition: 0.3s opacity;
    text-align: center;

    .title {
      font-size: 2rem;
      text-transform: uppercase;
      display: block;
    }

    .sub-title {
      font-size: 1.15rem;
      font-style: italic;
      display: block;
    }
  }

  .card-media-overlay-icon {
    opacity: 0.5;
    font-size: 6rem;
  }

  .card-media-overlay-badges {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 5px;
    transition: 0.3s background-color;

    background-color: rgba(0, 0, 0, 0.5);

    .badge {
      color: white;
    }
  }
`;
